import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ConversationsPage } from '../../pages/ConversationsPage';

export const Route = createFileRoute('/c/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ConversationsPage />;
}
